export function buildDailyChartData(rows = [], formatCompactLabel) {
  const groups = new Map();
  rows.forEach((row) => {
    const key = row.label;
    if (!groups.has(key)) {
      groups.set(key, {
        label: key,
        compactLabel: formatCompactLabel(row),
        detailsByProvider: {},
      });
    }
    const group = groups.get(key);
    group[row.provider] = row.unit_price;
    group.detailsByProvider[row.provider] = {
      locationName: row.locationName,
      locationCode: row.locationCode,
      productName: row.productName,
    };
  });
  return Array.from(groups.values());
}

export function getDailyTooltipDetails({ payload = [], chartData = [], label, labelKey = "label", preferPayload = false } = {}) {
  const activeEntry = payload.find((item) => typeof item.value === "number");
  const activeRow = preferPayload
    ? activeEntry?.payload
    : chartData.find((row) => row[labelKey] === label) || activeEntry?.payload;
  return activeRow?.detailsByProvider?.[activeEntry?.dataKey] || null;
}
